import { render, staticRenderFns } from "./UnSearchCenter.vue?vue&type=template&id=aae604e8&scoped=true&"
import script from "./UnSearchCenter.vue?vue&type=script&lang=js&"
export * from "./UnSearchCenter.vue?vue&type=script&lang=js&"
import style0 from "./UnSearchCenter.vue?vue&type=style&index=0&id=aae604e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae604e8",
  null
  
)

export default component.exports